import React from 'react';
import {connect} from "react-redux";
import Translate from "~/Components/ContentTranslate/Translate";

const EventTextShow = ({event, name, classes, defaultValue}) => {

    if (!event) { return <></> }

    const text = event.texts.find(t => t.name === name)

    return (
        <span className={classes}>
            {text?.text ? <Translate model={text} field="text" /> : defaultValue || ''}
        </span>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(EventTextShow);
